import { Tabs, TabsVariant } from '@dexma/ui-components';
import SaveWidgetContainer from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/Save';
import WidgetTypePresetContainer from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/WidgetTypePreset';
import {
    StyledConfigFlexContainer,
    StyledConfigFlexScrollContent,
} from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/style';
import TabSideMenuConfiguration from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Common';
import DataForm from 'adapter/in/common/form/data/DataForm';
import OptionsForm from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/OptionForm';
import i18n from 'asset/translation';
import { ErrorData } from 'domain/types';
import { Option, some } from 'fp-ts/lib/Option';
import React, { ReactElement } from 'react';
import { ConfigFieldType } from 'adapter/in/common/form/types';

type PanelWidgetConfigurationProps = {
    selectedTab: ConfigFieldType;
    fields: ReactElement[];
    options: ReactElement[];
    isLoading: boolean;
    error: Option<ErrorData>;
    errorAction?: () => void;
    isTabWithError: (currentTab: string) => boolean;
    featurePresetText: string;
};

export const isSelectedTab = (selectedTab: ConfigFieldType, comparedTab: ConfigFieldType): boolean => selectedTab === comparedTab;

const PanelWidgetConfiguration = (props: PanelWidgetConfigurationProps): ReactElement => {
    const { selectedTab, fields, options, isLoading, error, errorAction, isTabWithError, featurePresetText } = props;
    const optionTabSelected = isSelectedTab(selectedTab, ConfigFieldType.OPTIONS);
    const dataTabSelected = isSelectedTab(selectedTab, ConfigFieldType.DATA);
    const items = [
        {
            key: ConfigFieldType.DATA,
            label: <TabSideMenuConfiguration title={i18n.t('widgets.widgetMenu.data')} withError={isTabWithError(ConfigFieldType.DATA)} />,
            children: dataTabSelected ? (
                <DataForm
                    data={some(fields)}
                    isLoading={isLoading}
                    error={error}
                    errorAction={errorAction}
                    featurePresetText={featurePresetText}
                />
            ) : null,
            disabled: optionTabSelected,
        },
        {
            key: ConfigFieldType.OPTIONS,
            label: (
                <TabSideMenuConfiguration
                    title={i18n.t('widgets.widgetMenu.options')}
                    withError={isTabWithError(ConfigFieldType.OPTIONS)}
                />
            ),
            children: optionTabSelected ? (
                <OptionsForm data={some(options)} isLoading={isLoading || options.length === 0} error={error} errorAction={errorAction} />
            ) : null,
            disabled: dataTabSelected,
        },
    ];

    return (
        <StyledConfigFlexContainer data-testid='panel-widget-config'>
            <WidgetTypePresetContainer />
            <StyledConfigFlexScrollContent>
                <Tabs defaultActiveKey={selectedTab} activeKey={selectedTab} variant={TabsVariant.SCROLLABLE} items={items} />
            </StyledConfigFlexScrollContent>
            <SaveWidgetContainer />
        </StyledConfigFlexContainer>
    );
};

export default PanelWidgetConfiguration;
